import { CascadiaTypographyStyle, textStyles } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";

import { getTextDecorationStyle } from "../../components/utils";

export function getTextStyle(
  style: CascadiaTypographyStyle = "global/body-primary"
) {
  const values = textStyles[style];

  return css(
    {
      fontSize: `var(--${values.size})`,
      fontWeight: `var(--${values.weight})`,
      lineHeight: `var(--${values.lineHeight})`,
      fontFamily: `var(--${values.fontFamily})`,
    },
    getTextDecorationStyle(values.decoration)
  );
}
